import React, { Component } from 'react';
import { connect } from 'react-redux';
import ListingsFiltersView from './ListingFilters.view';

export class ListingsFiltersContainer extends Component {
  render() {
    return (<ListingsFiltersView
      {...this.props}
    />);
  }
}

function mapStateToProps(state) {
  return {
  };
}

export default connect(mapStateToProps)(ListingsFiltersContainer);



// WEBPACK FOOTER //
// ./src/app/modules/Ebay/Listings/ListingFilters/ListingFilters.container.js